import React from 'react';
import PropTypes from 'prop-types';
import ReactHighChart from './../HighChart';
import getConfig from './config';

const LineGraph = props => (
  <ReactHighChart
    container={props.containerId}
    options={getConfig(props.seriesData, props.height)}
  />
);

LineGraph.propTypes = {
  containerId: PropTypes.string.isRequired,
  seriesData: PropTypes.arrayOf(PropTypes.object).isRequired,
  height: PropTypes.number
};

LineGraph.defaultProps = {
  height: null
};

export default LineGraph;
